import React, {
    Component
} from 'react';
import {
    domainUrl
} from '../config/Config';
import {
    UserId
} from '../helpers/User';
import {
    getFormValues
} from '../helpers/Fields';
import {
    reactLoader,
    getTokenData,
    getUserData,
    message,
    scrollToTop,
    ObserverEcoachMessage,
    contentResizeLoad,
    showSmallLeftMenu,
    objToSlashString
} from '../helpers/Common';
import {
    runValidation
} from '../helpers/Validation';
import Inputgenerator from '../components/Inputgenerator';
import TimerCountDown from '../components/TimerCountDown';
import SelectLearnerObserver from './partials/SelectLearnerObserver';
import ThanksMessage from './partials/ThanksMessage';
import AssessementViewList from './partials/AssessementViewList';
export default class ContextQuestionnaire extends Component {
    constructor(props) {
        super(props);
        this.submitObserverandProceed = this.submitObserverandProceed.bind(this);
        this.state = {
            questionaireName: "",
            questionaireType: "",
            welcomeMessage: "",
            noOfQuestions: "",
            timeForCompletion: 0,
            timerSeconds: 0,
            canRate: false,
            canAccessLR: false,
            altText: "",
            agInfo: "",
            questions: [],
            dynamicFormData: "",
            componentStatus: this.props.data.status,
            statusMessage: "",
            AssessementViewData: [],
            showCompletedMessage: false,
            showAssessementTable: false,
            ratingText: "",
            rating: ""
        };
    }
    getContextDetails(data) {
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "get-context-form", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                mentor: getUserData("mentor", true),
                data: data
            })
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status === 0) {
                message(responseJson.message, responseJson.errors, "error");
            } else {
                let assessementTable = responseJson.data.observerEvaluation || (responseJson.data.evaluationEcoach === '1'),
                    ratingText, rating;
                if (this.props.data.status === "completed" && responseJson.data.canRate) {
                    ratingText = responseJson.data.ratingText;
                    rating = responseJson.data.rating;
                }
                this.setState({
                    questionaireName: responseJson.data.questionaireName,
                    questionaireType: responseJson.data.questionaireType,
                    welcomeMessage: responseJson.data.welcomeMessage,
                    noOfQuestions: responseJson.data.noOfQuestions,
                    timeForCompletion: responseJson.data.timeForCompletion,
                    timerSeconds: (responseJson.data.timeForCompletion * 60),
                    canRate: responseJson.data.canRate,
                    canAccessLR: responseJson.data.canAccessLR,
                    agInfo: responseJson.data.agInfo,
                    altText: responseJson.data.altText,
                    questions: responseJson.data.questions,
                    dynamicFormData: responseJson.data,
                    showAssessementTable: assessementTable,
                    ratingText: ratingText,
                    rating: rating,
                    statusMessage: ObserverEcoachMessage({
                        evaluation_mentor: responseJson.data.evaluationMentor,
                        evaluation_ecoach: responseJson.data.evaluationEcoach,
                        mentor_perform: responseJson.data.mentorPerform,
                        ecoach_perform: responseJson.data.ecoachPerform,
                        mentor_view: responseJson.data.mentorView,
                        ecoach_view: responseJson.data.ecoachView
                    })
                });
                if (assessementTable && data.status === "completed") {
                    this.getAssessors();
                }
                setTimeout(() => {
                    contentResizeLoad();
                    showSmallLeftMenu();
                    contentResizeLoad();
                    reactLoader("hide");
                }, 200);
            }
        });
    }
    getAssessors() {
        const {
            data
        } = this.props;
        let query_data = objToSlashString({
            learner_id: UserId(),
            seq_id: data.compseq_id,
            lroom_id: data.learning_room_id,
            dlr_id: data.dlr_id,
            comp_id: data.id,
            type: "context_questionaire"
        });
        fetch(domainUrl + "mentor-assess/view" + query_data, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            }
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status === 1) {
                this.setState({
                    AssessementViewData: responseJson.data
                })
            }
        });
    }
    componentDidMount() {
        const {
            data
        } = this.props;
        this.getContextDetails(data);
    }
    componentWillReceiveProps(nextProps) {
        const {
            data
        } = nextProps;
        this.getContextDetails(data);
    }
    submitContextForm() {
        if (runValidation()) {
            let dynamicFormData = getFormValues(this.state.dynamicFormData);
            let rating = this.refs.rating !== undefined ? this.refs.rating.value : 0;
            const {
                data
            } = this.props;
            reactLoader("show");
            fetch(domainUrl + "post-context-form", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + getTokenData()
                },
                body: JSON.stringify({
                    mentor: getUserData("mentor", true),
                    form_data: dynamicFormData,
                    rating: rating,
                    data: data
                })
            }).then((response) => response.json()).then((responseJson) => {
                reactLoader("hide");
                if (responseJson.status === 0) {
                    message(responseJson.message, responseJson.errors, "error");
                } else {
                    scrollToTop();
                    if (responseJson.isCompletedFully) {
                        this.goToThanksPage();
                    } else {
                        let showCompletedMessage = (responseJson.componentStatus === "completed") ? true : false,
                            ratingText = this.state.canRate ? responseJson.ratingText : "",
                            rating = this.state.canRate ? responseJson.rating : "",
                            questions = (responseJson.componentStatus === "completed")
                                ? responseJson.questions
                                : this.state.questions;
                        this.setState({
                            componentStatus: responseJson.componentStatus,
                            showCompletedMessage: showCompletedMessage,
                            questions: questions,
                            ratingText: ratingText,
                            rating: rating
                        })
                    }
                }
            });
        }
    }
    goToThanksPage() {
        const {
            data
        } = this.props;
        this.props.returnthanks({
            "status": "completed",
            "learning_room_id": data.learning_room_id,
            "compseq_id": data.compseq_id,
            "divider_id": data.divider_id,
            "dlr_id": data.dlr_id,
            "learner_id": data.learner_id,
            "is_ag": data.is_ag,
            "id": data.id,
            "compo_type": "thanks",
            "look_before": data.compseq_id,
            "flowresult": true
        });
    }
    submitObserverandProceed(obj) {
        const {
            data
        } = this.props;
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "context/observer-proceed", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                form_data: this.state.dynamicFormData,
                observers: obj,
                data: data
            })
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            if (responseJson.status === 0) {
                message("OOPS!", "Something went wrong. Please try again later.", "error");
            } else {
                scrollToTop();
                if (responseJson.isCompletedFully) {
                    this.goToThanksPage();
                } else {
                    let ratingText = this.state.canRate ? responseJson.ratingText : "",
                        rating = this.state.canRate ? responseJson.rating : "";
                    this.setState({
                        questions: responseJson.questions,
                        componentStatus: "completed",
                        showCompletedMessage: true,
                        ratingText: ratingText,
                        rating: rating
                    })
                }
            }
        });
    }
    goBackToComponentList() {
        const {
            data
        } = this.props;
        this.props.switchback("component_list", data.learning_room_id, data.dlr_id);
    }
    render() {
        const questionHtml = this.state.questions.map((val, key) => {
            return <div key={`context_question_${key}`} className="lr-gray-box test">
                <span className="bluetxt">Q{key+1}.</span>
                <span className="quetn" dangerouslySetInnerHTML={{__html:val.questionLabel}} />
                <div className="test-ques">
                    {
                        val.questionAnswer !== "" &&
                        <div className="analog-ans-bg">
                            <span style={{color: "#1e7bc0", fontWeight: "500"}}>Answer: </span>
                            <span style={{fontWeight: "400"}}>{val.questionAnswer}</span>
                        </div>
                    }
                    {
                        val.questionAnswer === "" &&
                        <span className="question_txt_an"><Inputgenerator qDetails={val} /></span>
                    }
                </div>
            </div>
        });
        var timer, timerNote;
        if (this.state.componentStatus === "" && this.state.timeForCompletion > 0) {
            timer = <TimerCountDown seconds={this.state.timerSeconds} onComplete={(e)=>this.submitContextForm()} />
            timerNote = <div className="ans-explanation"><b>To attend the next live session, you must complete this component in {this.state.timeForCompletion} minute(s).</b></div>
        }
        const centerHtml = <section className="scroll" id="semana-scroll-inner">
            <section className="viewport">
                <section className="overview" style={{top: "0px"}}>
                    <div className="inner-content analog">
                        {
                            this.state.componentStatus === "incompleted" &&
                            <div className="custom-react-wrapper">
                                <ThanksMessage message={this.state.statusMessage} />
                                <SelectLearnerObserver submitObserverandProceed={this.submitObserverandProceed} />
                            </div>
                        }
                        {
                            this.state.componentStatus === "" &&
                            <div className="custom-react-wrapper">
                                {
                                    this.state.welcomeMessage !== "" &&
                                    <div className="ans-explanation" dangerouslySetInnerHTML={{__html:this.state.welcomeMessage}} />
                                }
                                {
                                    timerNote
                                }
                                <div className="custom-react-wrapper">
                                    <span className="orgtxt noofques">Number of Questions : {this.state.noOfQuestions}</span>
                                    {questionHtml}
                                    <div style={{clear: "both"}}></div>
                                </div>
                                {
                                    this.state.canRate &&
                                    <div className="learnerrating3 ans-explanation">
                                        <span className="question_txt">
                                            <span className="myrate">I would rate my efforts in actioning this component as <span className="txt-red">*</span></span>
                                            <span className="myrate-select">
                                                <select ref="rating" className="required" data-error-required="Please rate your performance">
                                                    <option value="">Select rating</option>
                                                    <option value="1">Poor ( 1 )</option>
                                                    <option value="2">Below Average ( 2 )</option>
                                                    <option value="3">Average ( 3 )</option>
                                                    <option value="4">Above Average ( 4 )</option>
                                                    <option value="5">Good ( 5 )</option>
                                                    <option value="6">Excellent ( 6 )</option>
                                                    <option value="7">Outstanding ( 7 )</option>
                                                </select>
                                            </span>
                                        </span>
                                    </div>
                                }
                                {
                                    this.state.canAccessLR &&
                                    <div style={{textAlign: "right"}}>
                                        <input type="button" className="button_org" value="Submit" title="Submit" onClick={()=>this.submitContextForm()} />
                                    </div>
                                }
                            </div>
                        }
                        {
                            this.state.componentStatus === "completed" &&
                            <div className="custom-react-wrapper">
                                {
                                    this.state.showCompletedMessage &&
                                    <div className="ans-explanation success-msg">Successfully completed the Session.</div>
                                }
                                {
                                    this.state.showAssessementTable &&
                                    <AssessementViewList data={this.state.AssessementViewData} />
                                }
                                {
                                    this.state.canRate &&
                                    <div className="LERresult">My effort rating of this component is - <b>{this.state.rating} {this.state.ratingText}</b></div>
                                }
                                <span className="orgtxt noofques">Number of Questions : {this.state.noOfQuestions}</span>
                                {questionHtml}
                                <div style={{clear: "both"}}></div>
                                {(this.props.usableType=="webapp")?<div style={{textAlign: "right"}}>
                                    <input type="button" className="button_org" value="Continue" title="Continue" onClick={()=>this.goBackToComponentList()} />
                                </div>:""}
                            </div>
                        }
                    </div>
                </section>
            </section>
        </section>
        return (<div className="custom-react-wrapper">
        {
            this.state.agInfo !== "" &&
            <div className="custom-react-wrapper">
                <div className="action_goals">
                    {timer}
                    <div className="img_action_goal"><img src={process.env.PUBLIC_URL +"/images/img_action_goal1.gif"} width="58" height="82" alt="Action Goal" title="Action Goal" border="0" /></div>
                    <div className="ag_title_arrow">{this.state.agInfo.name}</div><br />
                    <div className="slash_adAG">
                        <div align="left" className="aq_active_button" title={this.state.altText}></div>
                        <div className="pgad_txt"><span className="pgad_title">{this.state.questionaireName}</span></div>
                        <span className="lm_subtitle">{this.state.questionaireType}</span>
                    </div>
                </div>
                {centerHtml}
            </div>
        }
        {
            this.state.agInfo === "" &&
            <div className="main-inner">
                {timer}
                <div className="border-box">
                
                    <div className={this.state.questionaireType?"title-box":"title-box tit-new"}>
                        <div className="aq_complete_button" title={this.state.altText}></div>
                        <h6>{this.state.questionaireName}</h6><span className="bluetxt">{this.state.questionaireType}</span>
                    </div>
                    {centerHtml}
                </div>
            </div>
        }
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/ContextQuestionnaire.js